import AppRouter from "./AppRouter.tsx";
import { useLayoutEffect } from 'react';

// Third-party styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'nouislider/src/nouislider.less';

// Custom styles last to ensure they override other styles
import "./../assets/css/style.scss"
import "../../styles.scss"
export const App = () => {
    const handleToggleClick = (e: Event) => {
        const trigger = (e.target as Element).closest('.js_toggle_trigger');
        if (!trigger) return;
        
        e.preventDefault();
        
        let toggleTarget: Element | null = null;
        
        if (trigger instanceof HTMLElement) {
            const dataTarget = trigger.getAttribute('data-target');
            const href = trigger.getAttribute('href');

            if (dataTarget) {
                toggleTarget = document.querySelector(dataTarget);
            } else if (href) {
                toggleTarget = document.querySelector(href);
            } else {
                toggleTarget = trigger.closest('.js_toggle');
            }

            const activeClass = trigger.classList.contains('js_toggle_trigger_slider')
                ? 'm-active-slider'
                : trigger.classList.contains('js_toggle_trigger_video')
                    ? 'm-active-video'
                    : 'm-active';

            const removeClass = trigger.classList.contains('js_toggle_trigger_slider')
                ? 'm-active-video'
                : trigger.classList.contains('js_toggle_trigger_video')
                    ? 'm-active-slider'
                    : '';

            if (toggleTarget) {
                toggleTarget.classList.toggle(activeClass);
                if (removeClass) {
                    toggleTarget.classList.remove(removeClass);
                    // Assuming pauseVideo is defined elsewhere
                    // pauseVideo();
                }
            }
        }
    };

    useLayoutEffect(() => {
        // Add single event listener to document
        document.addEventListener('click', handleToggleClick);

        // Cleanup
        return () => {
            document.removeEventListener('click', handleToggleClick);
        };
    }, []);

    return (
        <AppRouter />
    );
}

export default App;
